// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"809e6683","1303":"809e6683","3040":"809e6683","3588":"809e6683","3948":"809e6683","7023":"809e6683","8911":"809e6683"}[chunkId] + ".chunk.css";
};